import { createAsyncThunk } from "@reduxjs/toolkit";
import { ActionTypes } from "../constants/action-types";
import { apiCall } from "../../api/api";
import axios from "axios";

export const fetchInventoryByPhone = createAsyncThunk(
  ActionTypes.GET_INVENTORY_BY_PHONE,
  async (body: { phone: string; carrierId: number }, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        "booking-inventory-tool/fetch-inventory",
        "post",
        body
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getFullInventory = createAsyncThunk(
  ActionTypes.GET_FULL_INVENTORY,
  async (body: { phone: string; carrierId: number }, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        "booking-inventory-tool/get-inventory",
        "post",
        body
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const saveInventory = createAsyncThunk(
  ActionTypes.SEND_FILTERED_INVENTORY,
  async (body: { sessionId: string; inventory: any }, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        "booking-inventory-tool/save-inventory",
        "post",
        body
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const sendInventoryText = createAsyncThunk(
  ActionTypes.SEND_INVENTORY_TEXT,
  async (
    body: { phone: string; businessName: string },
    { rejectWithValue }
  ) => {
    try {
      const res = await apiCall(
        "booking-inventory-tool/send-text",
        "post",
        body
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const autoRedirectToInventory = createAsyncThunk(
  ActionTypes.REDIRECT_TO_INVENTORY,
  async (body: any, { rejectWithValue }) => {
    const { phone } = body;
    try {
      const res = await apiCall(
        `booking-inventory-tool/redirect-inventory`,
        "post",
        {
          phone,
        }
      );
      return res;
    } catch (error: any) {
      // return custom error message from API if any
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

// export const fetchBookingInventoryFromImage = createAsyncThunk(
//   ActionTypes.FETCH_INVENTORY_FROM_IMAGE,
//   async (
//     formData: FormData,
//     { rejectWithValue }
//   ) => {
//     try {
//       const res = await apiCall(
//         "booking-inventory-tool/upload-inventory",
//         "post",
//         formData,
//         { headers: { "Content-Type": "multipart/form-data" } }
//       );
//       return res;
//     } catch (error: any) {
//       if (error.response && error.response.data.message) {
//         return rejectWithValue(error.response.data.message);
//       } else {
//         return rejectWithValue(error.message);
//       }
//     }
//   }
// );

export const fetchBookingInventoryFromImage = createAsyncThunk(
  ActionTypes.FETCH_INVENTORY_FROM_IMAGE,
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const jwt = await localStorage.getItem("jwtToken");
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}booking-inventory-tool/upload-inventory`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${jwt}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return res.data;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const calculateBoxCount = createAsyncThunk(
  ActionTypes.CALCULATE_BOX_COUNT,
  async (
    body: { volume: number; stuffFactor: number; inventoryId: number },
    { rejectWithValue }
  ) => {
    try {
      const res = await apiCall(
        "booking-inventory-tool/calculate-box-count",
        "post",
        body
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const saveSmartMovingLeadId = createAsyncThunk(
  ActionTypes.SMART_MOVING_LEAD_ID,
  async (
    body: { inventoryId: number, leadId: string},
    { rejectWithValue }
  ) => {
    try {
      const res = await apiCall(
        "booking-inventory-tool/save-lead-id",
        "post",
        body
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);